module.exports = __webpack_public_path__ + "f5775732e11e878c817faeb21740d7a9.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/graphics/ecomm-white.png
// module id = 772
// module chunks = 0